<template>
  <div
    class="container"
  >
    <Card
      class="errorCard"
    >
      <template v-slot:body>
        <ParagraphBody>
          An error occurred while attempting to retrieve the Password Manager Status.
          Please try again.
        </ParagraphBody>
      </template>
      <template v-slot:footer>
        <div>
          <Button
            data-test-id="PasswordManagerErrorMessage_retryButton"
            hasOutline
            text="Retry"
            type="error"
            @click="handleRetry"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import {
  Button,
  Card,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'PasswordManagerErrorMessage',

  components: {
    Button,
    Card,
    ParagraphBody,
  },

  methods: {
    handleRetry() {
      this.$emit('retry');
    },
  },

};
</script>

<style scoped>
.container {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: var(--jc-spacer-large);
}

.errorCard.errorCard {
  background-color: var(--jcError50);
  width: 35rem;
}
</style>
